import { createFileRoute } from '@tanstack/react-router';
import { PlatformAgentsPage } from '../../screens/settings/PlatformAgents';

export const Route = createFileRoute('/settings/platform/agents')({
  component: PlatformAgentsPage,
});
